import React, {useContext, useEffect, useState} from "react";
import {EditRounded} from "@mui/icons-material";
import {Button, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, IconButton, Radio, Stack} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import {useTranslation} from "react-i18next";
import {useForm, FormProvider} from "react-hook-form";
import {AxiosError} from "axios";
import {useRecoilState, useRecoilValue} from "recoil";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {generalInfoState, proposalInfoState} from "../../../search-dms/state";
import {updateProposalInfo} from "../../../search-dms/dmsSearch.actions";
import {SET_SNACKBAR} from "../../../common/utils";
import { FormRadioGroup } from "../../../common/form-fields-wrappers";
import {useHasScope} from "../../../../../config/globalConfig";
import {NetworkScope} from "../../../types";

const ProposalInfo = () => {
    const hasScope = useHasScope;
    const {t} = useTranslation(['network', 'translation']);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const [proposalInfo,setProposalInfo] = useRecoilState(proposalInfoState);
    const generalInfo: any = useRecoilValue(generalInfoState);
    const proposalInfoForm = useForm({
        defaultValues: {
            truck: proposalInfo?.truck == true ? "Yes" : "No",
        }
    });
    const onSubmit = (data: any) => {
        const reqParameters = {
            id: generalInfo.id,
            truck: data.truck == "Yes" ? true : false,
        }
        setOpen(false);
        setIsDisabled(true);
        updateProposalInfo(reqParameters)
            .then( (res:any) => {
                setProposalInfo(res.proposalInfo);
            })
            .catch((err: AxiosError) => {
                dispatchGlobalData(SET_SNACKBAR.ERROR);
            });

    }
    const [isDisabled, setIsDisabled] = useState(true);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleDisableForm = (value:boolean) => {
        setIsDisabled(value);
    }

    useEffect(() => {
        proposalInfoForm.setFocus("truck");
        proposalInfoForm.setValue("truck",proposalInfo?.truck == true ? "Yes" : "No");
    },[proposalInfo])
    
    return(
        <>
            <FormProvider {...proposalInfoForm}>
                <Grid container direction="row" alignItems="start" columnSpacing={2}>
                    <Grid item xs={12}>
                        <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                            {(hasScope(NetworkScope.MsMng) && isDisabled) &&
                                <IconButton color={"accent"} onClick={() => {handleDisableForm(false)}}>
                                    <EditRounded/>
                                </IconButton>
                            }
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormRadioGroup
                            control={proposalInfoForm.control}
                            name="truck"
                            label={t('dmsDetail.proposalInfo.form.label.truck')}>
                            <FormControlLabel
                                disabled={isDisabled}
                                value="Yes"
                                control={<Radio/>}
                                label={t('dmsDetail.proposalInfo.form.label.yes')} />
                            <FormControlLabel
                                disabled={isDisabled}
                                value="No"
                                control={<Radio />}
                                label={t('dmsDetail.proposalInfo.form.label.no')} />
                        </FormRadioGroup>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                            { !isDisabled &&
                                <Button variant="contained" onClick={handleOpen} >
                                    {t('dmsDetail.proposalInfo.button.label.edit')}
                                </Button>
                            }
                        </Stack>
                    </Grid>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t('dmsDetail.proposalInfo.dialog.title')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {t('dmsDetail.proposalInfo.dialog.content')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant={"outlined"} color={"accent"}>
                            {t('dmsDetail.proposalInfo.dialog.action.cancel')}
                        </Button>
                        <Button autoFocus onClick={proposalInfoForm.handleSubmit(onSubmit)}>
                            {t('dmsDetail.proposalInfo.dialog.action.confirm')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </FormProvider>
        </>
    )
}

export default ProposalInfo;